import { Component } from "react";
import { connect } from "react-redux";
import { TreeSelect } from "antd";
import { sortBy } from "lodash-es";

import {
    SET_ACTIVE_REPORT
} from "common/actions/reports";

const transformToTreeSelectData = function(array = []) {
    return sortBy(array.map(({ _id, admin_report_name, canonical_name, children }) => ({
        value: canonical_name || _id,
        label: admin_report_name,
        // selectable: !children?.length, // Only allow selection of child items
        children: transformToTreeSelectData(children)
    })), ["label"]);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    SET_ACTIVE_REPORT
};

export const ReportListRedux = connect(mapStateToProps, mapDispatchToProps)(class extends Component {
    handleReportSelection = (value) => {
        this.props.SET_ACTIVE_REPORT(value);
        this.props.clearCache();
    };
    
    render() {
        if (this.props.all_reports?.hasError) {
            return <p>Sorry! There was an error loading the items</p>;
        }
        
        if (!this.props.all_reports?.loaded || this.props.all_reports?.isLoading) {
            return <div className="loader text-input__loading--line long"/>;
        }
    
        return (
            <TreeSelect
                showSearch
                treeDefaultExpandAll
                value={this.props.id}
                style={{ width: "400px" }}
                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                treeData={transformToTreeSelectData(this.props.all_reports?.data.filter((report) => !report.hidden))}
                placeholder="Select a report to view"
                onChange={this.handleReportSelection}
            />
        );
    }
});
